<template>
  <div class="guideRight">
    <Affix :offset-top="0" @on-change="changeAffix">
      <div class="fixed-card">
        <div class="card">
          <!-- <Button
            type="primary"
            size="large"
            long
            v-if="showAffix"
            large
            @click="gotoDeclare"
            >立即申报</Button
          > -->
          <div
            class="c-title"
            style="
              height: 3rem;
              text-align: center;
              background-color: #1472FF;
              color: #ffffff;
            "
          >
            发布部门
          </div>
          <!-- <div style="text-align: center;padding: 15px 0">{{deptObject==null?'暂无数据':deptObject.deptName}}</div> -->
          <div class="flex-row flex-center" style="height: 3rem">
            <!-- <el-button type="warning" size="small" icon="el-icon-star-on" @click.stop="clickIsFollow">{{isFollow ? '取消关注' : '关注'}}</el-button> -->
            <!-- <el-button type="primary" size="small" @click="gotoDept">查看详情</el-button> -->
            <!-- <span>{{ deptObject.fbjg }}</span> -->
            <span>{{ deptObject.deptName }}</span>
          </div>
        </div>

        <div class="card" style="margin-top: 50px;">
          <div class="c-title" style="height: 3rem; text-align: center;background-color:#1472FF;color:#ffffff">
            政策附件
          </div>
          <div class="flex-row flex-center"   v-for="item in fileList" :key="item.fileId">
            <span class="downFile" @click="download(item)" style="cursor:pointer;padding: 5px 10px;color: #1A73E8;">
              {{ item.fileName }}
            </span>
          </div>
        </div>
      </div>
    </Affix>
    <div class="content-box">
      <!-- <div class="relative-policy">
        <div class="r-title">
          {{ isPlolicy == "0" ? "相关政策" : "相关通知" }}
        </div>
        <ul>
          <li
            class="r-li"
            v-for="(item, i) in relativePolicy"
            :key="i"
            @click="gotoPolicy(item)"
          >
            <a class="max-two-line r-name">{{ item.name }}</a>
            <div class="flex-row-between r-content">
              <span class="max-one-line r-dept">{{ item.dept_name }}</span>
              <span class="r-date">{{ item.date }}</span>
            </div>
          </li>
        </ul>
      </div> -->
      <!-- <div class="relative-policy">
        <div class="r-title">相关专项</div>
        <ul>
          <li
            class="r-li"
            v-for="(item, i) in zhuanxiangList"
            :key="i"
            @click="gotoProject(item)"
          >
            <a class="max-two-line r-name">{{ item.name }}</a>
            <div class="flex-row-between r-content">
              <span class="max-one-line r-dept">{{ item.deptName }}</span>
              <span class="r-remark">{{ item.remark }}</span>
            </div>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "guideRight",
  props: {
    isPlolicy: {
      type: String,
      default: function () {
        return "0";
      },
    },
    //有deptName和deptId两个字段
    deptObject: {
      type: Object,
      default: function () {
        return null;
      },
    },
    id: {
      type: String,
      default: function () {
        return "0";
      },
    },
    deptid: {
      type: String,
      default: function () {
        return "0";
      },
    },
  },
  created() {},
  data() {
    return {
      fileList: [],
      collectItemId:
        this.deptObject.deptId == "0" ? "" : this.deptObject.deptId,
      showAffix: false,
      isFollow: false, //是否已经关注 已经关注为true
      relativePolicy: [
        {
          name: "“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）",
          dept_name: "工信局",
          remark: "资金支持",
          date: "2020-10-09",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）",
          dept_name: "发展改革委发展改革委发展改革委",
          remark: "资金支持",
          date: "2020-10-11",
        },
      ],
      zhuanxiangList: [
        {
          name: "“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）",
          deptName: "工信局",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）",
          deptName: "发展改革委",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及",
          deptName: "发展改革委",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及",
          deptName: "发展改革委",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）“通济才智”工程引进培养重点人才分类认定及评定实施细则（修订）",
          deptName: "工信局",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及",
          deptName: "发展改革委",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及",
          deptName: "发展改革委",
          remark: "资金支持",
        },
        {
          name: "“通济才智”工程引进培养重点人才分类认定及",
          deptName: "发展改革委",
          remark: "资金支持",
        },
      ],
      currentDeptName: this.deptName,
      currentDeptId: "",
      deptData: this.deptObject,
    };
  },
  mounted() {
    // 拿到
    this.getRelevance();
    this.getCollectList();
    this.listFile();
  },
  methods: {
    download(val) {
      val.url = val.url.replace("10.50.41.2", "111.6.83.65:8010");
      window.open(val.url + "/download");
    },
    // 查询业务材料附件列表
    listFile() {
      let detailType = this.$route.query.detailType;
      let url = "/dev-api/system/file/fileList";
      console.log("政策file");
      if (detailType == 1) {
        if (this.deptObject.fileId) {
        this.$httpApi
          .get(url, { fileId: this.deptObject.fileId })
          .then((res) => {
            this.fileList = res.rows;
          })
          .catch((e) => {});
      }
      } else {
        if (this.deptObject.remark) {
          let fileId = [];
          let newarr = JSON.parse(this.deptObject.remark);
          newarr.forEach((element) => {
            fileId.push(element.fileId);
          });
          this.$httpApi
            .get(url, { fileId: fileId.join(",") })
            .then((res) => {
              this.fileList = res.rows;
              console.log("政策fileDate", res);
            })
            .catch((e) => {});
        }
      }
    },
    //查询是否关注了该部门
    getCollectList() {
      if (this.$store.getters.getUserInfo) {
        let identify = this.$store.getters.getUserInfo.shxydm;
        let param = {
          identify: identify,
          type: "7",
          collectionId: this.deptObject.deptId,
          pageNum: 1,
          pageSize: 100,
        };
        let url = "/dev-api/collection/list";
        console.log("关注参数：", param);
        this.$httpApi
          .get(url, param)
          .then((res) => {
            console.log("收藏部门", res);
            if (res.code == 200) {
              res.total === 0
                ? (this.isFollow = false)
                : (this.isFollow = true);
              this.collectItemId = res.rows[0].id || "";
            }
          })
          .catch((err) => {});
      }
    },
    clickIsFollow() {
      if (this.$store.getters.getUserInfo) {
        if (this.isFollow) {
          this.cancelCollect();
        } else {
          this.collect();
        }
      } else {
        this.$emit("clickIsFollow", this.item);
      }
    },
    gotoDept() {
      this.$router.push({
        path: "/deptInfo/" + this.deptObject.deptId,
      });
    },
    changeAffix(flag) {
      this.showAffix = flag;
    },
    gotoDeclare() {
      this.$emit("gotoDeclare");
    },
    gotoPolicy(item) {
      /*    let { href } = this.$router.resolve({
        path: "/notice/detail/" + item.id + "?type=" + item.itemtype,
      });
      window.open(href, "_blank");*/
      this.$router.push({
        path: "/notice/detail/" + item.id + "?type=" + item.itemtype,
      });
    },
    gotoProject(item) {
      // this.$message({
      //   type: "warning",
      //   message: "功能开发中,敬请期待",
      // });
    },
    getRelevance() {
      let params = {
        pageNum: 1,
        pageSize: 10,
        policyid: this.id,
      };
      console.log(params);
      this.$httpApi
        .get(`/dev-api/basicinfo/baseitem/policyItemlist`, params)
        .then((res) => {
          console.log("关联的事项和公告:", res);
          if (res.code === 200) {
            this.relativePolicy = res.rows;
          }
        })
        .catch((err) => {
          this.$message({
            message: "网络异常，请稍后重试",
            type: "error",
          });
        });
    },
    //关注  TYPE为7为部门关注
    collect() {
      let id = this.deptObject.deptId;
      let identify = this.$store.getters.getUserInfo.shxydm;
      let name = this.deptObject.deptName;
      let collectedType = "7";
      let param = {
        collectionName: name,
        collectionId: id,
        identify: identify,
        type: collectedType,
      };
      console.log("收藏参数：", param);
      this.$httpApi
        .post("/dev-api/collection/install", param)
        .then((res) => {
          console.log("添加收藏" + JSON.stringify(res));
          if (res.code == 200 && res.data) {
            this.collectItemId = res.id;
            this.isFollow = true;
          }
        })
        .catch((err) => {});
    },
    //取消收藏
    cancelCollect() {
      let collectItemId = this.collectItemId;
      console.log("取消收藏参数：", collectItemId);
      this.$httpApi
        .post("/dev-api/collection/delete/" + collectItemId, {})
        .then((res) => {
          console.log("取消收藏" + JSON.stringify(res));
          if (res.code == 200) {
            this.collectItemId = "";
            this.isFollow = false;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/com/flex.scss";

.fixed-card {
  background: #ffffff;
  z-index: 999;
  padding: 0;
}

.card {
  border: 1px solid rgb(226, 226, 226);

  // margin-bottom: 20px;
  .c-title {
    padding: 10px;
    font-size: 15px;
    color: #000;
    border-bottom: 1px solid rgb(226, 226, 226);
  }

  .c-content {
    padding: 14px 0;
    font-size: 15px;
    text-align: center;
  }
}

.relative-policy {
  border: 1px solid rgb(226, 226, 226);
  margin-bottom: 30px;

  .r-title {
    font-size: 15px;
    padding: 10px;
    color: #000;
  }

  .r-li {
    border-top: 1px solid rgb(226, 226, 226);
    padding: 12px 10px;

    .r-name {
      color: #000;
      font-size: 13px;
      width: 100%;
    }

    .r-content {
      font-size: 11px;
      color: #000;
      padding-top: 8px;

      .r-dept {
        margin-right: 16px;
      }

      .r-remark {
        // color: #f00;
        flex-shrink: 0;
      }

      .r-date {
        flex-shrink: 0;
      }
    }
  }
}
</style>
